import { keepPreviousData, useQuery } from '@tanstack/vue-query'
import { computed, toValue, type MaybeRefOrGetter } from 'vue'
import { propertyKeys } from './propertyQueryKeys'
import { getProperties } from './propertyEndpoints'
import { parsePropertyList } from './propertyParser'
import { PROPERTIES_PAGE_LIMIT } from '../constants/propertyLifecycle'
import type { PropertyListFilters } from '../types/propertyTypes'

// One numbered page of the seller's properties — the Properties table's pager,
// narrowed by the quick filter and the search box server-side. `keepPreviousData`
// holds the current rows on screen while the next page loads.
export function usePropertiesPageQuery(
  page: MaybeRefOrGetter<number>,
  filters: MaybeRefOrGetter<PropertyListFilters>,
) {
  return useQuery({
    queryKey: computed(() => propertyKeys.page(toValue(filters), toValue(page))),
    queryFn: () => {
      const { bucket, search } = toValue(filters)
      return getProperties({
        page: toValue(page),
        limit: PROPERTIES_PAGE_LIMIT,
        bucket,
        search,
      }).then(parsePropertyList)
    },
    placeholderData: keepPreviousData,
  })
}
